<template>
  <div>
    <b-row>
      <b-col cols="9">
        <div class="card mx-2">
          <div class="card-body">
            <label class="fs-5 mt-3 mb-4"> {{ this.$route.params.id == undefined ? 'Add' : 'Edit' }} User</label>
            <b-row class="py-2">
              <b-col>
                <div class="d-inline me-2">
                  <label>Status</label>
                </div>
                <div class="form-check form-switch form-switch-md d-inline">
                  <input
                    v-model="user.isActive"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    class="form-check-input float-none"
                    block
                    v-b-toggle.accordion-2
                  />
                </div>
              </b-col>
            </b-row>
            <b-row class="py-3">
              <b-col>
                <label for=""
                  >Name <span style="color: red">*</span></label
                >
                <input
                  v-model="user.name"
                  type="text"
                  id="default-input"
                  placeholder="Enter Name"
                  class="form-control"
                  trim
                  :class="{
                    'is-invalid': submitted && $v.user.name.$error,
                  }"
                />
                <div
                  v-if="submitted && !$v.user.name.required"
                  class="invalid-feedback"
                >
                  Name is required.
                </div>
              </b-col>
            </b-row>

            <b-row class="py-3">
              <b-col>
                <label for="">Role <span style="color: red">*</span></label>
                <b-form-select
                  v-model="user.role"
                  class="form-select shadow-none"
                  :options="roleOptions"
                  :class="{
                    'is-invalid': submitted && $v.user.role.$error,
                  }">
                  <template #first>
                      <b-form-select-option :value="null" disabled
                        >Select Role</b-form-select-option
                      >
                    </template>
                </b-form-select>
                <div
                  v-if="submitted && !$v.user.role.required"
                  class="invalid-feedback">
                  Role is required.
                </div>
              </b-col>
            </b-row>

            <b-row class="py-3">
              <b-col>
                <label for="">Email Address <span style="color: red">*</span></label>
                <b-form-input
                  :disabled="user.id != 0"
                  v-model="user.email"
                  type="email"
                  id="default-input"
                  placeholder="Enter Email Address"
                  class="form-control"
                  trim
                  :class="{
                    'is-invalid': submitted && $v.user.email.$error,
                  }"
                ></b-form-input>
                <!-- <div
                  v-if="submitted && !$v.user.email.required"
                  class="invalid-feedback"
                >
                  Email is required.
                </div> -->
                <div
                  v-if="submitted && !$v.user.email.error"
                  class="invalid-feedback"
                >
                  Email is invalid.
                </div>
              </b-col>
            </b-row>

            <b-row class="py-3">
              <b-col>
                <label for="">Contact Number</label>
                <b-form-input
                  v-model="user.contactNumber"
                  type="text"
                  id="default-input"
                  placeholder="Enter Contact Number (ex. 09XXXXXXXXX)"
                  class="form-control"
                  trim
                  onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                  :class="{
                    'is-invalid': submitted && $v.user.contactNumber.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.contactNumber.required"
                  class="invalid-feedback"
                >
                  Contact Number is required.
                </div>
              </b-col>
            </b-row>

            <div class="text-end mt-3 mb-3">
              <button
                type="button"
                class="btn w-sm btn-light"
                @click="$router.back()"
              >
                Cancel
              </button>
              <button
                type="button"
                :disabled="isLoading"
                class="btn w-sm ms-2 btn-primary"
                @click="submit()"
              >
                <span
                  v-if="isLoading"
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                {{ user.id == 0 ? "Create" : "Update" }}
              </button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import { usersMethods, usersComputed, rolesMethods, rolesComputed, layoutMethods, layoutComputed } from "@/state/helpers";
import { getModuleAccess } from '@/helpers/helper.js'
// import Swal from "sweetalert2";

const parsePhoneNumber = require("awesome-phonenumber").parsePhoneNumber;

export default {
  page: {
    title: "User",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      isLoading: false,
      action: "",
      user: {
        id: 0,
        orgId: "",
        username: "",
        name: "",
        role: null,
        isActive: true,
        email: "",
        contactNumber: ""
      },
      roleOptions: [
        // { text: 'Test Admin', value: 'Test Admin' }
      ],
      submitted: false,
      oldMobile: "",
      toastTitle: "",
      toastMessage: "",
      toastType: "",
      showToast: false,
      access: {
        create: true,
        read: true,
        update: true,
        delete: true,
      },
    };
  },
  validations: {
    user: {
      name: { required },
      role: { required },
      email: { required, email }
    },
  },
  computed: {
    ...usersComputed,
    ...rolesComputed,
    ...layoutComputed
  },
  created() {},
  methods: {
    ...usersMethods,
    ...rolesMethods,
    ...layoutMethods,
    async submit() {
      if (this.action == 'create-user') {
        if (!this.access.create) {
          this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
          return
        }
      } else if (this.action == 'update-user') {
        if (!this.access.update) {
          this.$toast.showToast('warning', 'Forbidden', 'You are not allowed to do this operation.');
          return
        }
      }

      let prompAction = this.action == 'create-user' ? 'created' : 'updated';
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.user.name.$invalid || this.$v.user.role.$invalid || 
          this.$v.user.email.$invalid) {
        return; // prevent proceeding to creation if any of the required field is empty
      }

      var phoneInternational = null;
      if (this.user.contactNumber) {
        const pn = parsePhoneNumber(this.user.contactNumber, {
          regionCode: "PH",
        });
        if (pn.number.international) {
          phoneInternational = pn.number.international.replace(/\s/g, "");
        }
      }

      const params = {
        action: this.action,
        name: this.user.name,
        role: this.user.role,
        email: this.user.email,
        isActive: this.user.isActive ? 1 : 0,
        mobile: phoneInternational,
        createdBy: this.action == 'create-user' ? JSON.parse(localStorage.getItem("userData")).email : '',
        updatedBy: this.action == 'update-user' ? JSON.parse(localStorage.getItem("userData")).email : '',
      };

      if (this.action == 'create-user') {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha("signup");
        params.captcha = token
      } else if (this.action == 'update-user') {
        params.id = this.user.id
        params.username = this.user.username
        params.mobileIsChanged = this.oldMobile != phoneInternational ? true : false
      }
      
      this.isLoading = true;

      this.submitUser(params)
        .then((res) => {
          this.isLoading = false;
          let toastValues;
          if(res.status =='ok')
          {
            toastValues = {
              type: "success",
              title: "Success",
              message: `You successfully ${prompAction} a user.`
            }
          }
          else {
            if(res.message.code == 'UsernameExistsException')
            {
              toastValues = {
                type: "danger",
                title: "User already exists",
                message: "The user is currently associated with a different organization. Contact Support for Assistance."
              }
            }
            else {
              toastValues = {
                type: "danger",
                title: "Failed",
                message: "Unexpected error occurs. Please try again. Contact Support for Assistance."
              }
            }
              
          }
          
          console.log("submitUser:", res);
          this.$emit('show-toast', toastValues)
          if (res.status == 'ok') this.$router.back();
        })
        .catch(async (err) => {
          this.isLoading = false;
          console.log(err);
          this.$toast.showToast('danger', 'Error', 'Unexpected error occurs. Please try again.');
        });
    },
    async getUserById() {
      let params = {
        id: this.$route.params.id,
      };

      this.getUser(params)
        .then(() => {
          this.oldMobile = this.userItem.mobile;
          let phoneNumber = null;

          if(this.userItem.mobile){
            const pn = parsePhoneNumber(this.userItem.mobile, {
              regionCode: "PH",
            });
            if (pn.number.e164) {
              phoneNumber = pn.number.national.replace(/\s/g, "");
            }
          }

          this.user = {
            id: this.userItem.id,
            username: this.userItem.username,
            name: this.userItem.name,
            role: this.userItem.role,
            isActive: this.userItem.isActive,
            email: this.userItem.email,
            contactNumber: phoneNumber
          }
        })
        .catch(async (error) => {
          console.log("error: ", error);
          this.$toast.showToast('danger', 'Error', 'Unexpected error occurs. Please try again.');
        });
    },
    async getRoles() {
      this.getRolesList()
        .then(() => {
          for (let role of this.rolesList) {
            this.roleOptions.push({
              text: role.name,
              value: role.id
            })
          }
        })
        .catch(async (error) => {
          console.log("error: ", error);
          this.$toast.showToast('danger', 'Error', 'Unexpected error occurs. Please try again.');
        });
    },
  },
  async mounted() {
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "User Management" },
        { text: "Users", to: { name: 'users' } },
        { text: `${this.$route.params.id == undefined ? 'Add' : 'Edit'}` }
      ],
    });
    this.changeBackButton({
      value: true
    })
    this.changePrevRoute({
        name: 'users',
        params: {}
    })
    this.getRoles();
    if (this.$route.params.id != undefined) {
      this.action = 'update-user';
      this.getUserById();
    } else {
      this.action = 'create-user';
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess("User Management", "Users")
      .then((access) => {
        this.access = access
      }
    );
  },
};
</script>

<style>
.table {
  --bs-table-bg: transparent;
}

.custom-switch-size {
  font-size: 19px;
}

.swal2-bottom-end {
  margin-bottom: 4rem;
  width: fit-content !important;
  overflow-y: auto;
  margin-right: 6px !important;
}

.table td {
  width: 300px;
}

.td-no-padding {
  padding: 0;
}

.b-table-details td {
  padding: 0;
}

#sub-table td {
  padding: 0.75rem 0.75rem !important;
}

.hidden_header {
  display: none;
}
</style>
